<div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-p-8">

    <div class="tw-mb-4 tw-flex tw-h-16 tw-w-16 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#FFF9E6]">
        <i class="fa fa-clock-o tw-text-2xl tw-text-[#F9A825]"></i>
    </div>

    <h3 class="tw-mb-2 tw-text-2xl tw-font-bold tw-text-[#1A1A1A]">
        {{ 'unregisteredModal.applicationPending' | translate }}
    </h3>

    <span class="badge badge-pill badge-warning tw-mb-4 tw-px-4 tw-py-1 tw-text-xs tw-uppercase">
        {{ 'unregisteredModal.underReview' | translate }}
    </span>

    <p class="tw-mb-2 tw-text-center tw-text-gray-500">
        {{ 'unregisteredModal.submittedOn' | translate }}
    </p>

    <p class="tw-mb-6 tw-text-center tw-font-semibold tw-text-[#1A1A1A]">
        {{ submission?.createdAt | date: 'MMMM d, yyyy' }}.
    </p>

    <button class="btn btn-primary tw-mb-3 tw-h-12 tw-w-full"
            (click)="viewMyApplication()">
        {{ 'unregisteredModal.viewMyApplication' | translate }}
    </button>

    <div class="tw-relative tw-flex tw-w-full tw-items-center tw-py-3">
        <div class="tw-flex-grow tw-border-t tw-border-gray-200"></div>
        <span class="tw-mx-4 tw-text-sm tw-text-gray-400">{{ 'unregisteredModal.or' | translate }}</span>
        <div class="tw-flex-grow tw-border-t tw-border-gray-200"></div>
    </div>

    <button class="btn btn-outline-warning tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-gap-2"
            (click)="submitNewApplicationOverride()">
        <i class="fa fa-exclamation-triangle"></i>
        {{ 'unregisteredModal.submitNewApplicationOverride' | translate }}
    </button>

</div>
